enum LiveStreamStatus {
	creating = 'creating',
	available = 'available',
	deleting = 'deleting',
	deleted = 'deleted'
}

export enum LiveStreamState {
	available = 'available',
	paused = 'paused'
}

enum LiveStreamType {
	audio = 'audio',
	video = 'video'
}

enum LiveStreamIngestStateStatus {
	ingesting = 'ingesting',
	idle = 'idle',
	unavailable = 'unavailable'
}

enum LiveStreamIngestType {
	rtmp = 'rtmp',
	webdav = 'webdav',
	icecast = 'icecast'
}

export enum LiveStreamRestreamType {
	rtmp = 'rtmp'
}

export enum LiveStreamRestreamState {
	enabled = 'enabled',
	disabled = 'disabled'
}

// enum LiveStreamRestreamIngestState {
// 	ingesting = 'ingesting',
// 	rejected = 'rejected',
// 	idle = 'idle',
// 	error = 'error'
// }

export interface LiveApiError {
	code: string;
	message: string;
	errors?: string[];
}

export interface LiveCreateStream {
	data: {
		id: string;
		status: LiveStreamStatus;
		mediaclipid: string;
	};
}

export interface LiveDeleteStream {
	data: {
		id: string;
		type: LiveStreamType;
		status: LiveStreamStatus;
	};
}

export interface LiveIngestState {
	data: {
		state: LiveStreamIngestStateStatus;
		details?: any;
	};
}

export interface LiveStreamDetails {
	data: {
		id: string;
		type: LiveStreamType;
		'ingest-type': LiveStreamIngestType;
		publication: string;
		'stream-name': string;
		status: LiveStreamStatus;
		state: LiveStreamState;
		paused: boolean;
		recording: boolean;
		'stream-url': string;
		ingest?: any;
	};
}

export interface LiveStreamList {
	data: any[];
}

export interface LiveCreateRestream {
	data: {
		id: string;
	};
}

export interface LiveDeleteRestream {
	data: {
		success: boolean;
	};
}

export interface LivePublicationRestreamsList {
	data: LiveRestream[];
}

export interface LiveRestream {
	id: string;
	'restream-type': LiveStreamRestreamType;
	'restream-name': string;
	state: LiveStreamRestreamState;
	title?: string;
}

export interface LiveRestreamDetails {
	data: LiveRestream;
}

export interface LiveStreamRestreamsList {
	data: LiveRestream[];
}

export interface LiveUpdateRestreamState {
	data: {
		id: string;
		'request-status': boolean;
	};
}

export interface LiveUpdateStreamRecording {
	data: {
		id: string;
		'request-status': boolean;
	};
}

export interface LiveCreateRtmpDeliveryAlias {
	data: {
		id: string;
		'rtmp-app': string;
		'rtmp-streampath': string;
	};
}

export interface LiveDeleteRtmpDeliveryAlias {
	data: {
		success: boolean;
	};
}

export interface LiveGetRtmpDeliveryAlias {
	data: any[];
}
